<template>
  <div :class="{ 'ly-is-full': isFull }">
    <div class="tableSelect" ref="tableSelect">
      <el-form :inline="true" :model="formInline" ref="queryFrom" label-position="left">
        <el-form-item label="信件状态">
          <!-- <el-input v-model="formInline.search" placeholder="请输入主题名称"></el-input> -->
          <el-select
            v-model="formInline.status"
            placeholder="请选择信件状态"
            clearable
            filterabl
            style="width: 160px"
          >
            <el-option
              v-for="item in status"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button @click="handleSearchClick('search')" type="primary" icon="Search"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item label="">
          <el-button @click="handleSearchClick('reset')" icon="Refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <div class="tableToolBar">
				<div v-show="hasPermission($route.name,'Delete')"> 
					<el-button type="danger" icon="Delete" @click="removeHandler"
						:disabled="selectList.length == 0">删除</el-button>
				</div>
			</div>
      <el-table
        v-bind="tableOptions"
        :data="tableData"
        :height="tableHeight"
        ref="tableref"
        row-key="id"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" align="center" />
        <el-table-column prop="subject" label="主题" align="center" />
        <el-table-column prop="create_datetime" label="创建时间" align="center" />
        <el-table-column prop="update_datetime" label="更新时间" align="center" />
        <el-table-column label="状态" prop="status">
          <template #default="{ row, $index }">
            <el-tag v-if="row.status == '0'" type="primary">未读</el-tag>
            <el-tag v-else type="success">已读</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="300">
          <template #header>
            <div
              style="display: flex; justify-content: space-between; align-items: center"
            >
              <div>操作</div>
              <div @click="setFull">
                <el-tooltip content="全屏" placement="bottom">
                  <el-icon><full-screen /></el-icon>
                </el-tooltip>
              </div>
            </div>
          </template>
          <template #default="{ row, $index }">
            <div style="display: flex">
              <el-button
                icon="Pointer"
                type="primary"
                plain
                text
                size="small"
                @click="lookHandler(row)"
                >查看</el-button
              >
              <el-button icon="Delete" type="danger" v-show="hasPermission($route.name,'Delete')" plain text size="small" @click="removeRow(row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Pagination :child-msg="formInline" @callFather="callFather" />
    <ly-dialog
      v-model="dialogFlag"
      title="信件查看"
      width="40%"
      :before-close="handleDialogClose"
    >
      <div>
        <h2 class="title">{{ columnData.subject }}</h2>
        <div class="content" v-html="columnData.content"></div>
        <div class="article-link" v-if="columnData.attachments">
          <div
            style="font-size: 20px; font-weight: 500; margin-bottom: 15px; color: #015293"
          >
            相关附件
          </div>
          <div class="article-link-item">
            <span class="dot"></span>
            <div style="display: flex; justify-content: space-between; flex: 1">
              <span @click="downloadFileURLByA(columnData.attachments)">
              <!-- {{
                columnData.attachments
              }} -->
              附件下载
            </span>
              <span style="color: #7d7d7d">{{ columnData.create_datetime }}</span>
            </div>
          </div>
        </div>
      </div>
    </ly-dialog>
  </div>
</template>

<script setup>
import Pagination from "@/components/Pagination";
import { messageGet, messageDelete, messageGetDetail } from "@/api/court";
import LyDialog from "@/components/dialog/dialog";
import { ElMessage, ElMessageBox } from "element-plus";
import { getTableHeight } from "@/utils/util";
import { ref, reactive, watch, onMounted, onUnmounted, nextTick } from "vue";
import { downloadFileURLByA } from "@/utils/util";

const tableSelect = ref(null);
const isFull = ref(false);
const columnData = ref({});

const tableData = ref([]);
const tableHeight = ref(500);

const dialogFlag = ref(false);
const selectList = ref([]);

const formInline = reactive({
  page: 1,
  limit: 10,
  total: 0,
  search: "",
});
const status = ref([
  {
    id: 1,
    name: "已读",
  },
  { id: 0, name: "未读" },
]);
const tableOptions = ref({
  stripe: false, // 斑马纹
  highlightCurrentRow: false, // 是否要高亮当前行
  border: true, // 是否有纵向边框
  fit: true, // 列的宽度是否自撑开
  size: "default", // Table 的尺寸
  lazy: false, // 是否需要懒加载
  showHeader: true, //是否显示表头
  defaultExpandAll: false, //是否默认展开所有行
});

//初始化页面
function initPage() {
  messageGet(formInline).then((res) => {
    if (res.code == 2000) {
      formInline.total = res.data.total;
      tableData.value = res.data.data;
    }
  });
}

//搜索栏中的查询与重置按钮事件
function handleSearchClick(type) {
  if ("reset" == type) {
    formInline.name = "";
  }
  initPage();
}

//分页sizechange、pagechange事件
function callFather(params) {
  formInline.limit = params.limit;
  formInline.page = params.page;
  initPage();
}

//多选框选中的数据 将选中的数据放入selectList数组中
function handleSelectionChange(selection) {
  selectList.value = selection;
}

//dialog取消事件 清空输入框中的值
function handleDialogClose() {
  dialogFlag.value = false;
  initPage();
}

//表格中查看事件 data为那一行的数据
function lookHandler(data, i) {
  messageGetDetail(data).then((res) => {
    //更新
    dialogFlag.value = true;
    columnData.value = res.data.data;
  });
}

//表格中的删除事件 所有的删除事件需要进行一次确认 直接将这一行数据放到selectList数组中
function removeRow(data) {
  ElMessageBox.confirm("是否确认删除当前行的数据", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  }).then((f) => {
    remove([data]);
  });
}

//根据选中的数据进行删除 删除完毕后需要清空selectList数组
function removeHandler() {
  if (!selectList.value.length) return;
  ElMessageBox.confirm("是否确认删除选择的数据", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  }).then((f) => {
    remove(selectList.value);
  });
}

//通用发起删除请求
function remove(arr) {
  let flags = [];
  arr.map((item) => {
    messageDelete(item.id).then((res) => {
      if (res.code == 2000) {
        flags.push(true);
        if (flags.length == arr.length) {
          ElMessage.success("信件删除成功");
          initPage();
        }
      } else ElMessage.warning(res.msg);
    });
  });
}

function setFull() {
  isFull.value = !isFull.value;
  window.dispatchEvent(new Event("resize"));
}

function getTheTableHeight() {
  let tabSelectHeight = tableSelect ? tableSelect.value.offsetHeight : 0;
  tabSelectHeight = isFull.value ? tabSelectHeight - 110 : tabSelectHeight;
  tableHeight.value = getTableHeight(tabSelectHeight, false) - 225;
}

function listenResize() {
  nextTick(() => {
    getTheTableHeight();
  });
}

onMounted(() => {
  initPage();
  getTheTableHeight();
  window.addEventListener("resize", listenResize);
});

onUnmounted(() => {
  window.removeEventListener("resize", listenResize);
});
</script>

<style scoped lang="scss">
.tableToolBar {
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  background: var(--el-bg-color);
  padding: 8px;
  border-top: 1px solid var(--el-border-color-lighter);
  border-left: 1px solid var(--el-border-color-lighter);
  border-right: 1px solid var(--el-border-color-lighter);
}

.title {
  text-align: center;
  color: #355e92;
  font-size: 22px;
  margin-bottom: 35px;
}

.content {
  margin-bottom: 50px;
  padding-bottom: 30px;
  border-bottom: 3px solid #ddd;
}

.article-link {
  margin-bottom: 30px;

  .article-link-item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    cursor: pointer;

    .dot {
      content: "";
      display: table;
      width: 5px;
      height: 5px;
      background-color: #e1dfdf;
      margin-right: 5px;
    }

    &:hover .dot {
      background-color: #015293 !important;
    }

    &:hover {
      color: #015293;
    }
  }
}
</style>
